<template>
  <video
    v-bind="$attrs"
    ref="video"
    :muted
    controlslist=" nodownload noremoteplay noplaybackrate"
    disablePictureInPicture
    playsinline
    class="unselectable"
    @click="play"
  >
    <slot>
      <!-- <source :src type="video/mp4" />
      <track default kind="captions" /> -->
    </slot>
  </video>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
const video = ref<HTMLVideoElement>()
export interface Props {
  src?: string,
  muted?: boolean
}
const props = withDefaults(defineProps<Props>(), {})
const emit = defineEmits(['error'])
const isVideoPlaying = (): boolean => {
  if (video.value === null || video.value === undefined) return false
  return !!(
    video.value.currentTime > 0 &&
    !video.value.paused &&
    !video.value.ended &&
    video.value.readyState > 2
  )
}

const play = async (): Promise<void> => {
  if (video.value === null || video.value === undefined) return
  return await video.value.play().catch((error) => {
    console.log('error', error)
    const notAllowed = !String(error).includes('NotAllowedError')
    // eslint-disable-next-line no-console
    console.error(notAllowed ? error : 'Autoplay is not allowed')
    throw new Error(`${notAllowed ? error : 'Autoplay is not allowed'}`)
  })
}

const load = async (): Promise<void> => {
  if (video.value === null || video.value === undefined) return
  return video.value.load()
}
const pause = async (): Promise<void> => {
  if (video.value === null || video.value === undefined) return
  return video.value.pause()
}
const time = (): number | undefined => {
  if (video.value !== null && video.value !== undefined) return video.value.currentTime
  return undefined
}
const seek = (time: number): void => {
  if (video.value !== null && video.value !== undefined) {
    video.value!.currentTime = time
  }
}

const speed = (playbackRate: number = 1): void => {
  if (video.value !== null && video.value !== undefined) {
    video.value.playbackRate = playbackRate
  }
}
const getPlayback = (): number => {
  if (video.value !== null && video.value !== undefined) {
    return video.value.playbackRate
  }
  return 1
}

watch(() => props.src, (src) => {
  if (src) {
    video.value!.src = src
    try {
      video.value!.load()
      console.log('video loaded')
    } catch (error) {
      console.error('error', error)
      emit('error', error)
    }
  }
})
defineExpose({
  isVideoPlaying,
  play,
  pause,
  time,
  seek,
  speed,
  getPlayback,
  load
})
</script>
<style scoped lang="scss">
video {
  max-width: none !important;
}
</style>
